<template>
  <div class="prcie_ep">
    <Menu />
    <div class="cont">
      <pricingTop type="dt" />
      <div class="tabs">
        <router-link class="titem titem1" to="/pricing_individual.html">个人专属</router-link>
        <router-link class="titem titem1" to="/pricing_enterprise.html">企业专属</router-link>
        <router-link class="titem titem0" to="/pricing_desktron.html">云桌面</router-link>
      </div>
      
      <div class="mcompany">
          <div class="flexWrap">
              <!-- 公有云高性能桌面 -->
              <div class="mbox techsupport_box mhover_box">
                  <div class="mtop">
                      <p class="mttitle">高性能云电脑</p>
                      <p class="mtsubtitle">适用于云电竞/云设计场景</p>
                      <div class="m_content">
                          <p>
                              <span class="span1">CPU</span>
                              <span class="span2">8核16线程</span>
                          </p>
                          <p>
                              <span class="span1">内存</span>
                              <span class="span2">32GB</span>
                          </p>
                          <p>
                              <span class="span1">系统盘</span>
                              <span class="span2">240GB SSD</span>
                          </p>
                          <p>
                              <span class="span1">带宽</span>
                              <span class="span2">最高20Mbps</span>
                          </p>
                          <p>
                              <span class="span1">显卡</span>
                              <span class="span2">RTX3060</span>
                          </p>
                          <p>
                              <span class="span1">计费方式</span>
                              <span class="span2">小时/日/周</span>
                          </p>
                      </div>
                      <a :href="_daas_www_hostName" class="mtbtn">限时低价</a>
                  </div>  
              </div>
              <!-- 私有化部署 -->
              <div class="mbox prideploy_box mhover_box">
                  <div class="mtop">
                      <p class="mttitle">Desktron云桌面</p>
                      <p class="mttitle">私有化部署</p>
                      <p class="mtsubtitle">所有数据都保存在本地服务器</p>
                      <div class="mtprice">
                          <img class="get_server_pic" src="@/assets/pricing2/dt/dt_server.png" alt="">
                      </div>
                      <div class="mtprice_info"></div>
                      <a class="mtbtn mark_btn" @click="handleClick">咨询客户经理</a>
                      <div class="mtfeature">
                          <p class="mtfeature_item">
                              <img src="@/assets/pricing2/ep/sycheck@2x.png" alt="">
                              <span>极致高清流畅体验</span>
                          </p>
                          <p class="mtfeature_item">
                              <img src="@/assets/pricing2/ep/sycheck@2x.png" alt="">
                              <span>运维管理简单高效</span>
                          </p>
                          <p class="mtfeature_item">
                              <img src="@/assets/pricing2/ep/sycheck@2x.png" alt="">
                              <span>多种传输方案兼顾安全与性能</span>
                          </p>
                          <p class="mtfeature_item">
                              <img src="@/assets/pricing2/ep/sycheck@2x.png" alt="">
                              <span>深度兼容信创</span>
                          </p>
                      </div>
                  </div>
                
              </div>
          </div>
      </div>
      <Scenes :path="path"/>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import pricingTop from "@/components/pricingTop";
import Scenes from "@/views/pricingNext/Scenes.vue";

export default {
  components: {
    Menu,
    Footer,
    pricingTop,
    Scenes,
  },
  data() {
    return {
      path: "/desktron/contact",
    };
  },
  methods: {
    getService() {
      window.location.href = "https://enterprise.todesk.com/contact";
    },
    handleClick() {
      this.$router.push({
        path: "/desktron/contact",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.prcie_ep {
  background: #fff;

  .cont {
    padding-bottom: 24px;
    // background: url("~@/assets/pricing/pricing_bg@3x.png") no-repeat;
    background: linear-gradient(#ADDBFF, #FFFFFF);
    background-size: 100% auto;
    background-repeat: no-repeat;

    .tabs {
      width: fit-content;
      height: 50px;
      background: #FFFFFF;
      border-radius: 25px;
      padding: 4px;
      box-sizing: border-box;
      margin: auto;
      margin-top: 32px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, .05);

      .titem {
        width: 106px;
        height: 42px;
        border-radius: 21px;
        display: inline-block;
        text-align: center;
        line-height: 42px;
      }

      .titem0 {
        background: #37B3FC;
        box-shadow: 0px 2px 4px 0px rgba(0, 68, 152, 0.18);
        color: #131314;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }

      .titem1 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
    }
    .mcompany {
      // width: 1400px;
      margin: 24px auto 0px auto;
      .mbox {
        text-align: center;
        width: 326px;
        padding-bottom: 24px;
        margin: 0px auto;
      }
      .techsupport_box .mtop {
        border-top: 7px solid #38C0FF;
      }
      .mtop {
        min-height: 480px;
        box-sizing: border-box;
        padding-top: 30px;
        margin: 0px 5px 0px 5px;
        background: #ffffff;
        // border: 1px solid #DDE6ED;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      .mttitle {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #272727;
        line-height: 37px;
      }
      .mtsubtitle {
        margin-top: 8px;
        height: 44px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #88898D;
      }
      .mtbtn {
        width: 210px;
        height: 50px;
        border-radius: 4px;
        border: 1px solid #1AA3F2;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
        margin: auto;
        margin-top: 20px;
        display: block;
        background: #1AA3F2;
      }
      .mtbtn:hover {
        background: #1AA3F2;
        border-color: #1AA3F2;
        color: #fff;
      }
      .mtbtn:active {
        background: #0C97E8;
        border-color: #0C97E8;
      }
      .mark_btn1{
        width: 210px;
        height: 50px;
        border-radius: 4px;
        border: 1px solid #C4C8CC;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #C4C8CC;
        // cursor: pointer;
        margin: auto;
        margin-top: 20px;
      }
      .prideploy_box .mtop {
        border-top: 7px solid #FFBD33;
      }
      .mtprice {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 13px;
      }
      .mtprice .get_server_pic {
        width: 100px;
        height: 100px;
        position: relative;
        top: 50px;
      }
      .mtprice_info {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #88898D;
        line-height: 20px;
        height: 40px;
      }
      .mtfeature {
        height: 200px;
        padding-top: 16px;
        box-sizing: border-box;
        padding-left: 38px;
      }
      .mtfeature_item {
        height: 40px;
        display: flex;
        align-items: center;
      }
      .mtfeature_item img {
        width: 18px;
        height: auto;
        margin-right: 8px;
      }
      .mtfeature_item span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #272727;
      }
      .m_content {
        margin: 0px 42px;
        height: 253px;
      }
      .m_content p {
        margin-bottom: 20px;
        display: flex;
        color: #272727;
        font-size: 14px;
      }
      .m_content p span {
        flex: 1;
      }
      .m_content p .span1 {
        text-align: left;
      }
      .m_content p .span2 {
        text-align: right;
      }
      .m_select {
        width: 70px;
        padding: 5px 5px 5px 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 14px;
        color: #232729;
        background-color: #fff;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url(~@/assets/pricing2/dt/up.png);
        background-repeat: no-repeat;
        background-position: 50px center;
        background-size: 12px;
        background-size: 12px;
        padding-right: 20px;
      }
      .m_select::-ms-expand {
        display: none;
      }
      #application{
        scroll-margin-top: 70px;
      }
      .m_select:focus {
        outline: none;
      }
    }
  }
}</style>